import { prepareModelsShared1huernlq3uv7w as prepareModelsShared } from '../../../crowpay-shared/com/crowpay/prepareModelsShared.mjs';
import { Companion_getInstance3eoge8j03l9b5 as Companion_getInstance } from '../../../lightning-server-shared/com/lightningkite/serialization/SerializationRegistry.mjs';
import { Companion_getInstance1xwqxy6002qfp as Companion_getInstance_0 } from '../../../crowpay-shared/com/crowpay/URLs.mjs';
import { prepareModelsShared26ns7flh6i65f as prepareModelsShared_0 } from '../../../lightning-server-shared/com/lightningkite/prepareModelsShared.mjs';
import { Companion_getInstance37g5wqg3e7ywq as Companion_getInstance_1 } from '../../../kiteui-library/com/lightningkite/kiteui/exceptions/handling.mjs';
import { installLsError350ro3euqscko as installLsError } from '../../../lightning-server-kiteui-client/com/lightningkite/kiteui/exceptions/LsErrorHandlers.mjs';
import { Handler_instance26jr8uh1iqbs3 as Handler_instance } from './sdk/errors.mjs';
import { get_ClientModule2m5j3ywx3t162 as get_ClientModule } from '../../../lightning-server-shared/com/lightningkite/serialization/ClientModule.mjs';
import { set_DefaultSerializersModulehpe9ajem91ea as set_DefaultSerializersModule } from '../../../kiteui-library/com/lightningkite/kiteui/navigation/urls.mjs';
import {
  set_pageNavigator2t8ucpwsozusv as set_pageNavigator,
  set_mainPageNavigator2pkpulo0hvwfl as set_mainPageNavigator,
  set_dialogPageNavigator1900z53fhaufv as set_dialogPageNavigator,
  get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator,
} from '../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { bindToPlatformg7nl9tb6kj90 as bindToPlatform } from '../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.js.mjs';
import { get_sessionNotFound2vlo9fobx2iqb as get_sessionNotFound } from './sdk/UserSession.mjs';
import { println2shhhgwwt4c61 as println } from '../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { LogInScreen3qovz4fzwtjwv as LogInScreen } from './views/screens/auth/LogInScreen.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { crowpay2qzi7x0waf7w5 as crowpay } from './views/components/nav/crowpay.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function app(_this__u8e3s4, main, dialog) {
  prepareModelsShared();
  Companion_getInstance().x3i_1.f3j(Companion_getInstance_0().k2a());
  prepareModelsShared_0();
  installLsError(Companion_getInstance_1().jcw_1);
  Companion_getInstance_1().jcw_1.icw(Handler_instance);
  set_DefaultSerializersModule(get_ClientModule());
  set_pageNavigator(_this__u8e3s4, main);
  set_mainPageNavigator(_this__u8e3s4, main);
  set_dialogPageNavigator(_this__u8e3s4, dialog);
  bindToPlatform(main, _this__u8e3s4.pc());
  var tmp = get_sessionNotFound();
  tmp.vah(() => {
    println('Session not found');
    get_mainPageNavigator(_this__u8e3s4).gbw(new (LogInScreen())());
    return Unit_instance;
  });
  crowpay(_this__u8e3s4);
}
//region block: exports
export {
  app as appl9jr7k6l38bt,
};
//endregion

//# sourceMappingURL=app.mjs.map
